import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { composeLayouts, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';

export const globalSettingsLayout: Layout = composeLayouts(globalLayout);
